'use client'
import { LinkButtonNoMui as LinkButton } from 'components/LinkButtonNoMui/LinkButtonNoMui'
import { TypographyV2 as Typography } from 'components/Typography/TypographyV2'
import { MediaImageStandard } from 'components/Contentful/MediaImageStandard/MediaImageStandard'
import { useViewportSmallerThan } from 'utils/viewport'
import { BREAKPOINTS } from 'constants/viewport'
import classNames from 'classnames'
import { Carousel } from 'components/Carousels'
import {} from 'react'
import { SITE_ENVIRONMENTS } from 'constants/websites'
import { ThumbsUp } from 'react-feather'

function Card({ item: { cardImage, cardTitleText, cardText }, priority }) {
  const [quote] = cardText?.content ?? []
  return (
    <div className="flex flex-col-reverse justify-end items-start">
      <div className="w-1/2 py-0 px-4 lg:[&_data-[no-margin='false']]:p-0">
        <div className={'aspect-square h-[100px]'}>
          <MediaImageStandard
            layout={'fixed'}
            content={cardImage}
            fetchPriority="high"
            preload={priority}
            width={60}
            height={60}
          />
        </div>
        <Typography
          className={'pt-4 first:pt-4 not-first:pt-0 '}
          content={cardTitleText}
          fontWeight="bold"
          variant="displayLg"
          mobileVariant="displayMd"
          responsive={true}
        />
        <Typography className={'pr-8 pt-4'} content={quote} fontWeight="regular" variant="bodySm" />
      </div>
    </div>
  )
}

export default function ValuePropsClient({
  idContent,
  grid,
  config,
  linkButton,
  arrow,
  handwritten,
  backgroundConfigJson,
  sectionVariationObject,
}) {
  const jsonContent = backgroundConfigJson?.jsonContent || {}
  const hideButtonOnMobile = jsonContent?.hideButtonOnMobile || false
  const linkButtonClassNameMargin = jsonContent?.linkButtonClassNameMargin || ''
  const isMobile = useViewportSmallerThan(BREAKPOINTS.lg)
  const siteEnv = process.env.NEXT_PUBLIC_SITE_ENVIRONMENT || 'achieve'
  const aplStyling = jsonContent?.overrideStyle === 'apl'
  return (
    <>
      {isMobile && config.carouselOnMobile && (
        <Carousel
          className={'group-data-[no-margin="false"]:p-0'}
          carouselItems={grid?.gridItemsCollection?.items}
          itemComponent={Card}
          variant="preview-small-xs"
          idPrefix="value-props-carousel"
          withIndicators
          classNameIndicators={'[&_div]:bg-[#c0cbd8]'}
          classNameActiveDot={'bg-[#3300ff] opacity-100'}
        />
      )}

      {linkButton && !(isMobile && hideButtonOnMobile) && (
        <div
          className={classNames(
            'flex flex-col justify-center items-center w-full',
            `${
              aplStyling
                ? 'mt-0 sm:mt-[16px] lg:mt-[48px]'
                : `${linkButtonClassNameMargin ? linkButtonClassNameMargin : 'lg:mt-16'} ${
                    siteEnv === SITE_ENVIRONMENTS.FDR ? 'mt-8' : 'mt-12'
                  }`
            }`
          )}
        >
          <LinkButton
            className={classNames('min-w-[293px] h-[47px]', {
              'bg-[#cb000e]': siteEnv === SITE_ENVIRONMENTS.FDR,
            })}
            content={linkButton}
            typographicOptions={{
              fontWeight: 'bold',
            }}
            color={config.buttonColor ? config.buttonColor : 'primary'}
            data-testid={`value-prop-button-${idContent}`}
            track={{
              ...{
                list_name: 'Personalized Value Props CTA',
                click_id: linkButton.linkText?.json.content?.[0]?.content[0]?.value,
                click_text: linkButton.linkText?.json.content[0]?.content[0]?.value,
                click_url: linkButton.linkHref,
                nav_link_section: config.navLinkSection ?? 'Value Props',
                click_position: '0',
                track_event: 'internal_campaign_click',
                event_action: 'button_click',
                event_type: 'button_click',
              },
              ...linkButton.event,
              sectionVariationObject,
            }}
          />
          {aplStyling && (
            <div className="sm:hidden mt-[32px] flex flex-row content-center justify-center">
              <ThumbsUp color="#5C708A" height={16} width={16} />
              <div className=" flex items-center">
                <Typography
                  className="pl-[6px] text-center text-nowrap text-[12px] font-normal leading-[140%] text-[#5C708A]"
                  variant="bodyXs"
                  mobileVariant="bodyXs"
                  responsive={true}
                  content={'It’s quick, free, and won’t affect your credit score'}
                />
              </div>
            </div>
          )}
          {arrow && handwritten && (
            <>
              <div className={'relative rotate-372 ml-[-176px] mt-4 lg:ml-[-160px]'}>
                <MediaImageStandard
                  alt={arrow?.mediaAltText || 'Arrow'}
                  content={arrow.mediaContent}
                  layout="fixed"
                  height="30"
                  width="25"
                />
              </div>
              <div className={'mt-[-24px] lg:mt-[-22.4px] lg:ml-0'}>
                <MediaImageStandard
                  alt={handwritten?.mediaAltText || 'Handwrite'}
                  content={handwritten.mediaContent}
                  layout="fixed"
                  width="121"
                  height="19"
                />
              </div>
            </>
          )}
        </div>
      )}
    </>
  )
}
